import { request } from "/src/utils/index.js";

export function Search(params) {
  // console.log(parmas);
  return request.get("b2b/business/related/clubs", { params });
}

export function GetList(params) {
  // console.log(parmas);
  return request.get("sdcom/object/subject/list", { params });
}

export function Save(params) {
  return request.post("sys/group/employee", params);
}

export function Add(params) {
  return request.post("sdcom/object/subject", params);
}

export function saveOrder(params) {
  return request.post("sdcom/object/subject/sort", params);
}
export function Delete(data) {
  return request.delete("sdcom/object/subject", { data });
}

export function Detail(params) {
  return request.get("ai/innerStudy/list/medicine/overview", { params });
}

export function Edit(params) {
  return request.put("sdcom/object/subject", params);
}

export function SaveItems(params) {
  return request.put("/sdcom/object/subject/items", params);
}
